import { DataAttributes } from '../common';

const ANALYTICS_DATA_ATTRIBUTE_PREFIX = 'data-analytics-';

export enum ConfiguratorEntry {
  ConfigurationDetailsConfigureButton = 'Configuration Details Page - Configure Button',
  ProductAddConfigurationButton = 'Product Page - Add Configuration Button',
  ProductCreateConfigurationButton = 'Product Page - Configure Button',
  ProductGoToCheckoutButton = 'Product Page - Go To Checkout Button',
  ProductSuggestedConfiguration = 'Product Page - Suggested Configuration',
  WebshopProductConfiguratorLink = 'Webshop Product Page - Configurator Link',
}

interface Attributes {
  id?: string;
  label?: string;
  'configurator-entry'?: string;
  'file-category'?: string;
  product?: string;
  'product-code'?: string;
}

export class AnalyticsAttributes {
  public static get(attributes: Attributes): DataAttributes {
    return Object.entries(attributes).reduce<DataAttributes>((result, [key, value]) => {
      if (value !== undefined && value !== null) {
        result[`${ANALYTICS_DATA_ATTRIBUTE_PREFIX}${key}`] = value;
      }
      return result;
    }, {});
  }

  public static pick(props: object): DataAttributes {
    return Object.entries(props).reduce<DataAttributes>((result, [key, value]) => {
      if (key.startsWith(ANALYTICS_DATA_ATTRIBUTE_PREFIX)) {
        const k = key as keyof DataAttributes;
        result[k] = value as DataAttributes[typeof k];
      }
      return result;
    }, {});
  }

  public static merge(props: object, attributes: AnalyticsAttributes): DataAttributes {
    return { ...AnalyticsAttributes.pick(props), ...AnalyticsAttributes.get(attributes) };
  }
}
